import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { BookingStore } from '@store';
import { SubscriptionPlan } from '@vi-iot/client';

@Component({
  selector: 'app-commercial-booking-checkout',
  templateUrl: './commercial-booking-checkout.component.html',
  styleUrls: ['./commercial-booking-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialBookingCheckoutComponent implements OnDestroy {
  @Output() back = new EventEmitter<void>();

  BookingPlans = SubscriptionPlan;
  constructor(public bookingStore: BookingStore) {}

  onContinue(): void {
    this.bookingStore.subscribeCommercialPackage();
  }

  onBack(): void {
    this.back.emit();
  }

  ngOnDestroy(): void {
    this.bookingStore.resetSubscriptionsDetails();
  }
}
